(function () {
  "use strict";

  // ---------- config (defaults; overridden by sliders at each run start) ----------
  let LANES = 7;
  let LINE_TRAVEL_MS = 1000;   // time for a line to cross the full field, top to bottom
  let LINE_HEIGHT_PCT = 14;    // line thickness as % of field height
  let PLAYER_ROW_PCT = 82;     // player's fixed vertical position, % of field height
  let ROUND_MS = 30000;        // total round length
  let WIN_FRACTION = 0.75;     // uptime reaches 100% after this fraction of the round
  let HIT_PAUSE_MS = 3000;     // uptime growth freeze after a non-fatal hit
  let LIVES_INIT = 0;          // extra lives before a hit is fatal

  // ---------- dom refs ----------
  let field = document.getElementById("field");
  let lanesBg = document.getElementById("lanes-bg");
  let linesLayer = document.getElementById("lines-layer");
  let player = document.getElementById("player");

  let statusTag = document.getElementById("status-tag");
  let uptimeFill = document.getElementById("uptime-fill");
  let ttlFill = document.getElementById("ttl-fill");
  let ttlTag = document.getElementById("ttl-tag");
  let strikesTag = document.getElementById("strikes-tag");

  let splashScreen = document.getElementById("splash-screen");
  let gameoverScreen = document.getElementById("gameover-screen");
  let gameoverEyebrow = document.getElementById("gameover-eyebrow");
  let gameoverTitle = document.getElementById("gameover-title");
  let gameoverMessage = document.getElementById("gameover-message");

  let startBtn = document.getElementById("start-btn");
  let retryBtn = document.getElementById("retry-btn");

  let roundTimeSlider = document.getElementById("round-time");
  let roundTimeValueEl = document.getElementById("round-time-value");
  let livesSlider = document.getElementById("lives");
  let livesValueEl = document.getElementById("lives-value");
  let speedSlider = document.getElementById("speed");
  let speedValueEl = document.getElementById("speed-value");

  // ---------- lane background ----------
  (function buildLanes() {
    for (let i = 0; i < LANES; i++) {
      let div = document.createElement("div");
      div.className = "lane-divider";
      lanesBg.appendChild(div);
    }
  })();

  // ---------- state ----------
  let running = false;
  let playerCol = 3;
  let activeLine = null;   // { el, y, gapIndex, checked, cells }
  let startTime = 0;
  let lastFrame = 0;
  let rafId = null;
  let lives = 0;
  let growthElapsedMs = 0;   // cumulative time the uptime bar has been allowed to grow
  let pausedUntil = 0;       // timestamp until which uptime growth is frozen
  let winThresholdMs = 22500; // recomputed from ROUND_MS * WIN_FRACTION on each run

  function formatRoundTime(totalSeconds) {
    let m = Math.floor(totalSeconds / 60);
    let s = totalSeconds % 60;
    return String(m).padStart(2, "0") + ":" + String(s).padStart(2, "0");
  }

  function updateRoundTimeLabel() {
    roundTimeValueEl.textContent = formatRoundTime(parseInt(roundTimeSlider.value, 10));
  }

  function updateLivesLabel() {
    livesValueEl.textContent = livesSlider.value;
  }

  function updateSpeedLabel() {
    let percent = parseInt(speedSlider.value, 10);
    let seconds = 100 / percent;
    speedValueEl.textContent = percent + "% (" + seconds.toFixed(2) + "s)";
  }

  roundTimeSlider.addEventListener("input", updateRoundTimeLabel);
  livesSlider.addEventListener("input", updateLivesLabel);
  speedSlider.addEventListener("input", updateSpeedLabel);

  function readConfig() {
    let roundSeconds = parseInt(roundTimeSlider.value, 10);
    ROUND_MS = roundSeconds * 1000;
    winThresholdMs = ROUND_MS * WIN_FRACTION;

    let speedPercent = parseInt(speedSlider.value, 10);
    LINE_TRAVEL_MS = 1000 / (speedPercent / 100);

    LIVES_INIT = parseInt(livesSlider.value, 10);
  }

  function setSlidersDisabled(disabled) {
    roundTimeSlider.disabled = disabled;
    livesSlider.disabled = disabled;
    speedSlider.disabled = disabled;
  }

  function laneCenterPct(col) {
    return (col + 0.5) * (100 / LANES);
  }

  function setPlayerPosition() {
    player.style.left = laneCenterPct(playerCol) + "%";
  }

  function makeLine() {
    let el = document.createElement("div");
    el.className = "fw-line";
    el.style.height = LINE_HEIGHT_PCT + "%";
    el.style.top = -LINE_HEIGHT_PCT + "%";

    let gapIndex = Math.floor(Math.random() * LANES);

    for (let i = 0; i < LANES; i++) {
      let cell = document.createElement("div");
      cell.className = "fw-cell";
      if (i !== gapIndex) {
        let sq = document.createElement("div");
        sq.className = "fw-square";
        cell.appendChild(sq);
      }
      el.appendChild(cell);
    }

    linesLayer.appendChild(el);

    return { el: el, y: -LINE_HEIGHT_PCT, gapIndex: gapIndex, checked: false };
  }

  function clearLines() {
    linesLayer.innerHTML = "";
    activeLine = null;
  }

  function formatTime(ms) {
    let totalSec = Math.max(0, ms) / 1000;
    let m = Math.floor(totalSec / 60);
    let s = totalSec - m * 60;
    return String(m).padStart(2, "0") + ":" + s.toFixed(1).padStart(4, "0");
  }

  function setStatus(text, cls) {
    statusTag.textContent = text;
    statusTag.classList.remove("running", "failed", "cleared");
    if (cls) statusTag.classList.add(cls);
  }

  // ---------- game flow ----------
  function resetGame() {
    readConfig();

    clearLines();
    playerCol = 3;
    setPlayerPosition();
    activeLine = makeLine();
    startTime = null;
    lastFrame = null;
    running = true;

    lives = LIVES_INIT;
    growthElapsedMs = 0;
    pausedUntil = 0;

    setStatus("BREACHING", "running");
    strikesTag.textContent = "STRIKES LEFT " + lives;
    uptimeFill.style.width = "0%";
    ttlFill.style.width = "100%";
    ttlTag.textContent = "TTL " + formatTime(ROUND_MS);

    splashScreen.classList.add("hidden");
    gameoverScreen.classList.add("hidden");
    setSlidersDisabled(true);

    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(gameLoop);
  }

  function endGame(won, reason) {
    running = false;
    if (rafId) cancelAnimationFrame(rafId);
    setSlidersDisabled(false);

    if (won) {
      setStatus("ACCESS GRANTED", "cleared");
      gameoverEyebrow.textContent = "CONNECTION SECURE";
      gameoverTitle.textContent = "BREACH COMPLETE";
      gameoverTitle.classList.remove("failed-color");
      gameoverMessage.textContent = "Uptime reached 100% before the connection timed out. Run it again.";
    } else {
      setStatus("BREACH FAILED", "failed");
      gameoverEyebrow.textContent = "CONNECTION LOST";
      gameoverTitle.textContent = "BREACH FAILED";
      gameoverTitle.classList.add("failed-color");

      if (reason === "lives") {
        gameoverMessage.textContent = "Out of lives — the firewall caught the packet.";
      } else if (reason === "time") {
        gameoverMessage.textContent = "Uptime never reached 100% before the connection timed out.";
      } else {
        gameoverMessage.textContent = "The packet was dropped by the firewall.";
      }
    }

    gameoverScreen.classList.remove("hidden");
  }

  function gameLoop(timestamp) {
    if (!running) return;

    if (startTime === null) {
      startTime = timestamp;
      lastFrame = timestamp;
      pausedUntil = 0;
    }

    let dt = timestamp - lastFrame;
    lastFrame = timestamp;

    let elapsed = timestamp - startTime;
    let remaining = ROUND_MS - elapsed;

    // round clock (TTL) always drains regardless of hits
    let ttlPct = Math.max(0, (remaining / ROUND_MS) * 100);
    ttlFill.style.width = ttlPct + "%";
    ttlTag.textContent = "TTL " + formatTime(Math.max(0, remaining));

    // uptime only grows while not in a post-hit freeze
    if (timestamp >= pausedUntil) {
      growthElapsedMs += dt;
    }
    let uptimePct = Math.min(100, (growthElapsedMs / winThresholdMs) * 100);
    uptimeFill.style.width = uptimePct + "%";

    if (uptimePct >= 100) {
      endGame(true);
      return;
    }

    if (remaining <= 0) {
      endGame(false, "time");
      return;
    }

    // move the active line
    let speedPctPerMs = 100 / LINE_TRAVEL_MS; // full field height per LINE_TRAVEL_MS
    activeLine.y += speedPctPerMs * dt;
    activeLine.el.style.top = activeLine.y + "%";

    // collision check as the line reaches the player's row
    if (!activeLine.checked && activeLine.y + LINE_HEIGHT_PCT >= PLAYER_ROW_PCT) {
      activeLine.checked = true;
      if (playerCol !== activeLine.gapIndex) {
        if (lives > 0) {
          lives -= 1;
          strikesTag.textContent = "STRIKES LEFT " + lives;
          pausedUntil = timestamp + HIT_PAUSE_MS;
          flashHit();
        } else {
          endGame(false, "lives");
          return;
        }
      }
    }

    // line fully exited the bottom -> spawn a new one
    if (activeLine.y >= 100) {
      linesLayer.removeChild(activeLine.el);
      activeLine = makeLine();
    }

    rafId = requestAnimationFrame(gameLoop);
  }

  function flashHit() {
    field.classList.add("hit-flash");
    setTimeout(function () {
      field.classList.remove("hit-flash");
    }, 200);
  }

  // ---------- input ----------
  function moveLeft() {
    if (playerCol > 0) {
      playerCol -= 1;
      setPlayerPosition();
    }
  }

  function moveRight() {
    if (playerCol < LANES - 1) {
      playerCol += 1;
      setPlayerPosition();
    }
  }

  window.addEventListener("keydown", function (e) {
    // Space / Enter: start the run from the splash screen, or retry after it ends
    if (e.key === " " || e.key === "Enter" || e.key === "Spacebar") {
      if (e.repeat) return;
      if (!running && !splashScreen.classList.contains("hidden")) {
        e.preventDefault();
        resetGame();
        return;
      }
      if (!running && !gameoverScreen.classList.contains("hidden")) {
        e.preventDefault();
        resetGame();
        return;
      }
      return;
    }

    if (!running) return;
    if (e.repeat) return; // count each discrete keypress only, not OS auto-repeat

    switch (e.key) {
      case "ArrowLeft":
      case "a":
      case "A":
        moveLeft();
        e.preventDefault();
        break;
      case "ArrowRight":
      case "d":
      case "D":
        moveRight();
        e.preventDefault();
        break;
    }
  });

  // ---------- buttons ----------
  startBtn.addEventListener("click", resetGame);
  retryBtn.addEventListener("click", resetGame);

  // ---------- initial paint ----------
  setPlayerPosition();
  updateRoundTimeLabel();
  updateLivesLabel();
  updateSpeedLabel();
  strikesTag.textContent = "STRIKES LEFT " + livesSlider.value;
  ttlTag.textContent = "TTL " + formatTime(parseInt(roundTimeSlider.value, 10) * 1000);
  uptimeFill.style.width = "0%";
})();
